"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomScriptEventHandlerActivator = exports.CustomScriptEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class CustomScriptEventHandlerArgs {
    constructor(scriptId, scriptArgs) {
        this.scriptId = scriptId;
        this.scriptArgs = scriptArgs;
        this.__type = EventHandlerType_1.EventHandlerType.CustomScript;
        this.__typeName = "CustomScript";
    }
}
exports.CustomScriptEventHandlerArgs = CustomScriptEventHandlerArgs;
let CustomScriptEventHandlerActivator = class CustomScriptEventHandlerActivator {
    activate(sequence, container, handler, event) {
        Registries_1.EventHandlerScripts.getItem(handler.args.scriptId).run(sequence, container, handler, event);
    }
};
CustomScriptEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.CustomScript)
], CustomScriptEventHandlerActivator);
exports.CustomScriptEventHandlerActivator = CustomScriptEventHandlerActivator;
